


















































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import { CustomerInfo } from '@/domain/CustomerInfo'
import CustomersService from '@/service/CustomersService'

@Component
export default class CustomerSelectDialogComponent extends Vue {
  customersService = CustomersService.instance

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  /** 0:顧客選択 1:代表検索 2:代理店検索 3:合算請求対象検索  */
  @Prop({ default: 0 })
  type!: number

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "顧客名", value: "customerShortName" },
          { text: "部署名", value: "customerDepartment" },
          { text: "電話番号", value: "customerTel" },
          { text: '', value: 'data-table-expand' },
  ]
  itemsPerPage = 10
  expanded = []
  /** 検索キーワード */
  search = ""
  /** データテーブル フッター設定 */
  footerProps = {
    'disable-items-per-page': true,
    showFirstLastPage: true,
    firstIcon: 'mdi-skip-backward',
    lastIcon: 'mdi-skip-forward',
    prevIcon: 'mdi-skip-previous',
    nextIcon: 'mdi-skip-next'
  }
  list: CustomerInfo[] = []
  selected: CustomerInfo[] = []

  mounted () {
    switch (this.type) {
      case 1:
        /* 代表検索 */
        this.customersService.findRepresentativeAll().then(x => this.list = x)
        break;
      case 2:
        /* 代理店検索 */
        this.customersService.findAgencyAll().then(x => this.list = x)
        break;
      case 3:
        /* 合算請求対象検索 */
        this.customersService.findInvoiceAll().then(x => this.list = x)
        break;
      default:
        /* 通常検索 */
        this.customersService.findAll().then(x => this.list = x)
    }
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.selected[0])
  }
}
